export function shuttoConfig() {
  __stt.get("lang", function (lang) {
    $("html").attr("lang", lang);
    if ($("button[data-stt-changelang].active").attr("data-stt-changelang") !== lang ) {
      $("button[data-stt-changelang]").each(function () {
        $(this).removeClass("active");
        if ($(this).attr("data-stt-changelang") === lang) {
          $(this).addClass("active");
        }
      });
    }
  });
}
export function languageChangeText () {
  __stt.get("lang", function (lang) {
    if (lang === "ja") {
      $("span[data-txt-lang=language]").text("日本語");
    }
    if (lang === "en") {
      $("span[data-txt-lang=language]").text("English");
    }
    if (lang === "ru") {
      $("span[data-txt-lang=language]").text("Русский");
    }
  })
}